import React from 'react';
import propTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { Common } from 'ws-scripts/modules/common';

const HowItWorksText = (labels, extraClasses = '') => {
	return (
		<div className={`${extraClasses} box-border p-4`}>
			<p>{labels.get('WS_DR_TOOLBOX_TOOLTIP_INTRO')}</p>
			<strong>
				<p>{labels.get('WS_DR_TOOLBOX_TOOLTIP_DIFFERENCE_QUESTION')}</p>
			</strong>
			<p>{labels.get('WS_DR_TOOLBOX_TOOLTIP_PREQUAL_INFO')}</p>
			<p className="m-0">
				{labels.get('WS_DR_TOOLBOX_TOOLTIP_CREDIT_INFO')}
			</p>
		</div>
	);
};

const HowItWorks = ({ deviceType, widgetClasses }) => {
	// const tooltipClasses =
	// 	deviceType === 'DESKTOP'
	// 		? 'dr-tooltip-container'
	// 		: 'btn btn-primary mb-3';

	const primaryBG = widgetClasses.includes('bg-primary');

	return (
		<Common
			render={({ labels }) => {
				if (deviceType === 'DESKTOP') {
					return (
						<OverlayTrigger
							placement="left"
							trigger="hover"
							overlay={
								<Tooltip id="dr-toolbox-tooltip">
									{HowItWorksText(labels)}
								</Tooltip>
							}
						>
							<button
								className={`btn btn-link dr-tooltip-container ddc-font-size-small p-0 dr-tooltip-btn mb-2 ${
									primaryBG ? 'text-white' : ''
								}`}
							>
								{labels.get('HOW_THIS_WORKS')}&nbsp;
								<i className="ddc-icon ddc-icon-info" />
							</button>
						</OverlayTrigger>
					);
				} else {
					return (
						<div>
							<button
								className={`btn w-100 text-left ${
									primaryBG
										? 'btn-primary border-white'
										: null
								}`}
								data-toggle="collapse"
								data-target="#collapseExample"
								aria-expanded="false"
								aria-controls="collapseExample"
							>
								{labels.get('HOW_THIS_WORKS')}&nbsp;
								<i
									className={`ddc-icon ddc-icon-plus float-right ${
										primaryBG ? null : 'text-primary'
									}`}
								/>
							</button>
							<div className="collapse" id="collapseExample">
								{HowItWorksText(
									labels,
									primaryBG
										? 'border-white border'
										: 'bg-white'
								)}
							</div>
						</div>
					);
				}
			}}
		/>
	);
};

HowItWorks.propTypes = {
	deviceType: propTypes.string,
	widgetClasses: propTypes.string
};

HowItWorks.defaultProps = {
	deviceType: 'DESKTOP',
	widgetClasses: ''
};

export default HowItWorks;



// WEBPACK FOOTER //
// ./src/components/HowItWorks.jsx